// The load cover. A portrait page keeps its first paint under a cover in the canvas color
// until its parts have drawn, then fades the cover out, so nothing pops in. site.scss draws
// the cover, the head script puts it up, and home.ts takes it down. Without scripts, there's
// no cover.

/** Cover the page until `showPage()`, for at most `capMs`, so a part that never draws can't
    keep the page covered forever. */
export function holdPage(capMs: number): void {
  document.documentElement.dataset.loading = "";
  setTimeout(showPage, capMs);
}

export function showPage(): void {
  if (!("loading" in document.documentElement.dataset)) return;
  delete document.documentElement.dataset.loading;
  // Marks the reveal in a performance trace, since lab LCP counts content under the cover.
  performance.mark("reveal");
}
